export default __webpack_public_path__ + "static/media/image.codelk-private-limited.6cc12588.png";